const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
    },
    {
        title: 'Phone No.',
        dataIndex: 'phoneNo',
        render: defaultRender,
    },
    {
        title: 'Account No.',
        dataIndex: 'terminalId',
        render: defaultRender,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        render: defaultRender,
    },
    {
        title: 'Credit Type',
        dataIndex: 'type',
        render: defaultRender,
    },
    {
        title: 'Comment',
        dataIndex: 'comment',
        render: defaultRender,
    },
    {
        title: 'Created By',
        dataIndex: 'createdBy',
        render: defaultRender,
    },
    {
        title: 'Created At',
        dataIndex: 'createdDate',
        render: defaultRender,
    },
];

export default columns;